import {
  Box,
  Button,
  Checkbox,
  CircularProgress,
  Dialog,
  DialogContent,
  FormControlLabel,
  Grid,
  IconButton,
  TextField,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import Close from "@mui/icons-material/Close";
import {
  addDepartmentApi,
  updateDepartmentApi,
} from "../../../services/department.service";
import { toast } from "react-toastify";
import DepartmentSchema from "../../../joi/master/department.schema";

const HospitalDepartmentModal = ({
  open,
  onClose,
  refetch,
  selectedRow = null,
}) => {
  const initialState = {
    active: true,
    name: "",
    departmentCode: "",
  };

  const [formData, setFormData] = useState(initialState);
  const [isLoading, setIsLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((preValue) => ({
      ...preValue,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    let response;

    const { error } = DepartmentSchema.validate(formData);

    if (error) {
      error.details.forEach((err) => toast.error(err.message));
      return;
    }

    setIsLoading(true);
    if (selectedRow?._id) {
      response = await updateDepartmentApi(formData);
    } else {
      response = await addDepartmentApi(formData);
    }
    setIsLoading(false);

    if (response?.code === 200) {
      toast.success(
        response?.message ||
          `Deparment ${selectedRow?._id ? "updated" : "added"} successfully`
      );
      setFormData(initialState);
      onClose();
      refetch();
    } else {
      toast.error(response?.message || "Some error occurred.");
    }
  };

  // Sync selectedRow data when modal opens
  useEffect(() => {
    if (selectedRow?._id) {
      setFormData({
        ...initialState,
        _id: selectedRow._id,
        active: selectedRow?.active ?? true,
        name: selectedRow?.name || "",
        departmentCode: selectedRow?.departmentCode || "",
      });
    } else {
      setFormData(initialState);
    }
  }, [open]);

  return (
    <Dialog
      open={open}
      onClose={onClose}
      slotProps={{
        paper: {
          sx: {
            maxWidth: "unset",
            width: { xs: "95vw", lg: "1100px" },
            bgcolor: "#E5F4FF",
            borderRadius: "20px",
          },
        },
      }}
    >
      <DialogContent>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            mb: "20px",
          }}
        >
          <Typography sx={{ color: "rgba(93, 106, 130, 1)", fontSize: 20 }}>
            Add Hospital Department
          </Typography>
          <IconButton onClick={onClose}>
            <Close />
          </IconButton>
        </Box>
        <Box component="form" onSubmit={handleSubmit}>
          <Grid container spacing={2}>
            {/* name */}
            <Grid item xs={12} sm={6}>
              <TextField
                label="Name"
                name="name"
                required
                fullWidth
                value={formData?.name || ""}
                onChange={handleChange}
                sx={{ bgcolor: "white" }}
              />
            </Grid>

            {/* departmentCode */}
            <Grid item xs={12} sm={6}>
              <TextField
                label="Department Code"
                name="departmentCode"
                required
                fullWidth
                value={formData?.departmentCode || ""}
                onChange={handleChange}
                sx={{ bgcolor: "white" }}
              />
            </Grid>

            {/* active */}
            <Grid item xs={12}>
              <FormControlLabel
                control={
                  <Checkbox
                    name="active"
                    checked={formData?.active}
                    onChange={handleChange}
                  />
                }
                label="Active"
              />
            </Grid>
          </Grid>

          <Box sx={{ display: "flex", justifyContent: "center", mt: "20px" }}>
            <Button
              variant="contained"
              type="submit"
              sx={{
                textTransform: "none",
                backgroundColor: "rgba(1, 121, 176, 1)",
                width: "150px",
              }}
              disabled={isLoading}
            >
              {isLoading ? (
                <CircularProgress size={24} />
              ) : selectedRow?._id ? (
                "Update"
              ) : (
                `Submit`
              )}
            </Button>
          </Box>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default HospitalDepartmentModal;
